/* DeSiM 公式店 — 商品页A（無制限型・sections/main-product-unlimited.liquid）専用 JS。
   日数ピル / 「その他の日数」ドロップダウンで variant を切り替え、
   隠し input（name="id"）・価格パネル・sticky 底栏を同時に更新する。

   🔴 店は JPY 単一通貨（shop の通貨表示設定が「¥」+ 3桁区切りの整数固定）。
      他店（simless-global）は多通貨を開けており、そちらは通貨ごとに違う
      表示テンプレートの置換パターンを JS 側でも全種類賄う必要があるが
      （check-theme.mjs に専用の検査ルールがある）、desim は現状 JPY 固定なので
      ここでは単純に「¥」+ 3桁区切りだけ組む。将来 desim が多通貨を開けたら
      その置換ロジックに合わせて書き直すこと（今それをやるのはオーバーエンジニアリング）。 */
(function () {
  var form = document.querySelector('[data-ds-product-form]');
  if (!form) return;

  var variantInput = form.querySelector('[data-ds-variant-input]');
  var pillsWrap = form.querySelector('[data-ds-day-pills]');
  var otherSelect = form.querySelector('[data-ds-day-other]');
  var otherWrap = otherSelect ? otherSelect.closest('.ds-day-other') : null;
  var pills = pillsWrap
    ? Array.prototype.slice.call(pillsWrap.querySelectorAll('[data-variant-id]'))
    : [];

  var priceDaysEls = document.querySelectorAll('[data-ds-price-days]');
  var priceValueEls = document.querySelectorAll('[data-ds-price-value]');
  var perDayEls = document.querySelectorAll('[data-ds-per-day]');
  var stickyDaysEls = document.querySelectorAll('[data-ds-sticky-days]');
  var stickyValueEls = document.querySelectorAll('[data-ds-sticky-value]');

  function formatYen(cents) {
    var yen = Math.round(Number(cents) / 100);
    return '¥' + yen.toLocaleString('ja-JP');
  }

  function setText(nodeList, text) {
    for (var i = 0; i < nodeList.length; i++) nodeList[i].textContent = text;
  }

  function selectVariant(el) {
    if (!el) return;
    var id = el.getAttribute('data-variant-id');
    var price = el.getAttribute('data-price');
    var days = el.getAttribute('data-days');
    var title = el.getAttribute('data-title');
    var kindLabel = el.getAttribute('data-kind-label') || '完全無制限';

    if (variantInput) variantInput.value = id;

    pills.forEach(function (p) {
      p.classList.toggle('is-selected', p === el);
      p.setAttribute('aria-pressed', p === el ? 'true' : 'false');
    });
    if (otherWrap) otherWrap.classList.toggle('is-selected', el.tagName === 'OPTION');

    setText(priceDaysEls, title + '・' + kindLabel);
    setText(priceValueEls, formatYen(price));
    setText(stickyDaysEls, title + '・無制限');
    setText(stickyValueEls, formatYen(price));

    if (perDayEls.length && days) {
      var perDay = Math.floor(Number(price) / 100 / Number(days));
      setText(perDayEls, '¥' + perDay.toLocaleString('ja-JP'));
    }
  }

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      if (otherSelect) otherSelect.value = '';
      selectVariant(pill);
    });
  });

  if (otherSelect) {
    otherSelect.addEventListener('change', function () {
      var opt = otherSelect.options[otherSelect.selectedIndex];
      if (!opt || !opt.getAttribute('data-variant-id')) return;
      pills.forEach(function (p) {
        p.classList.remove('is-selected');
      });
      selectVariant(opt);
    });
  }
})();
